<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    div#toggle-services-view{
        position: absolute;
        z-index: 9;
        right: 15px;
        top: 90px;
        -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
        border-radius: 5px;

        span.toggle-button{
            cursor: pointer;
            display: inline-block;
            padding: 5px 20px;
            background-color: white;
            font-family: 'Raleway', sans-serif;
            text-align: center;
            font-weight: bold;

            &.map-view{
                border-top-left-radius: 5px;
                border-bottom-left-radius: 5px;

                &.active{
                    color: white;
                    background-color: $secondary-color;
                }
            }

            &.list-view{
                border-top-right-radius: 5px;
                border-bottom-right-radius: 5px;

                &.active{
                    color: white;
                    background-color: $secondary-color;
                }
            }
        }
    }
</style>

<template>
    <div id="toggle-services-view" v-show="$route.name == 'services'" v-if="app_env == 'local' || app_env == 'development'">
        <span class="map-view toggle-button" v-bind:class="{ 'active': servicesView == 'map' }" v-on:click="displayView('map')">{{ $t('general.mapView') }}</span><span class="list-view toggle-button" v-bind:class="{ 'active': servicesView == 'list' }" v-on:click="displayView('list')">{{ $t('general.listView') }}</span>
    </div>
</template>

<script>
    import { ROAST_CONFIG } from '../../config.js';

    export default {
        data() {
            return {
                app_env: ROAST_CONFIG.APP_ENV,
            }
        },

        computed: {
            servicesView() {
                return this.$store.getters.getServicesView;
            }
        },

        methods: {
            displayView(type) {
                this.$store.dispatch('changeServicesView', type);
            }
        }
    }
</script>
